
import React from "react";
import { Zap, TrendingUp, CloudLightning, Target, BarChart3 } from "lucide-react";
import SlideLayout from "../components/SlideLayout";

const CustomerTrendsSlide = () => {
  return (
    <SlideLayout>
      <div className="space-y-8">
        <h3 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 via-purple-600 to-pink-600 mb-6 font-cursive">
          Customer Behavior and Trends Moving Faster Than Ever
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white backdrop-blur-sm border border-violet-400 p-6 rounded-lg shadow-md transition-all hover:border-violet-500 hover:shadow-lg">
            <div className="flex items-start mb-4">
              <div className="bg-gradient-to-r from-violet-600 to-purple-600 p-2 rounded-lg mr-3">
                <Zap size={22} className="text-white" />
              </div>
              <h4 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600 font-cursive">Dynamic Learning Model</h4>
            </div>
            <p className="text-violet-900 font-cursive">
              Appella AI continuously learns from user feedback and evolving trends, enabling real-time recommendations while traditional algorithms rely on static rules and fixed patterns.
            </p>
          </div>
          
          <div className="bg-white backdrop-blur-sm border border-violet-400 p-6 rounded-lg shadow-md transition-all hover:border-violet-500 hover:shadow-lg">
            <div className="flex items-start mb-4">
              <div className="bg-gradient-to-r from-violet-600 to-purple-600 p-2 rounded-lg mr-3">
                <Target size={22} className="text-white" />
              </div>
              <h4 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600 font-cursive">Enhanced Personalization</h4>
            </div>
            <p className="text-violet-900 font-cursive">
              Uses a wide variety of data from past purchases, browsing history, customer questions, and contextual factors such as weather or occasion to capture the nuances of individual preferences.
            </p>
          </div>
          
          <div className="bg-white backdrop-blur-sm border border-violet-400 p-6 rounded-lg shadow-md transition-all hover:border-violet-500 hover:shadow-lg">
            <div className="flex items-start mb-4">
              <div className="bg-gradient-to-r from-violet-600 to-purple-600 p-2 rounded-lg mr-3">
                <BarChart3 size={22} className="text-white" />
              </div>
              <h4 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600 font-cursive">Improved Accuracy</h4>
            </div>
            <p className="text-violet-900 font-cursive">
              Continuous feedback means better predictions of what customers will like, resulting in higher engagement and conversion rates compared to static recommendation systems.
            </p>
          </div>
          
          <div className="bg-white backdrop-blur-sm border border-violet-400 p-6 rounded-lg shadow-md transition-all hover:border-violet-500 hover:shadow-lg">
            <div className="flex items-start mb-4">
              <div className="bg-gradient-to-r from-violet-600 to-purple-600 p-2 rounded-lg mr-3">
                <TrendingUp size={22} className="text-white" />
              </div>
              <h4 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600 font-cursive">Adaptive to Trends</h4>
            </div>
            <p className="text-violet-900 font-cursive">
              Fashion trends and consumer behavior change rapidly. Our AI adapts to these changes ensuring recommendations remain relevant, while rule-based algorithms lag behind emerging patterns.
            </p>
          </div>
        </div>
        
        <div className="mt-6 bg-gradient-to-r from-violet-100 to-indigo-100 p-6 rounded-lg border border-violet-300">
          <div className="flex items-center mb-3">
            <CloudLightning className="h-6 w-6 text-violet-700 mr-2" />
            <h4 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600 font-cursive">The Appella AI Advantage</h4>
          </div>
          <p className="text-violet-900 font-cursive">
            By leveraging advanced machine learning that continuously evolves, Appella AI provides a significant competitive edge over traditional static recommendation engines, keeping your business ahead of rapidly changing consumer preferences.
          </p>
        </div>
      </div>
    </SlideLayout>
  );
};

export default CustomerTrendsSlide;
